import { vehicleReturn } from "@App/apis/graphql/fleet/vehicleReturn";
import { vehicle } from "@App/apis/graphql/fleet/vehicle";

export const fleetApi = {
  vehicleReturn,
  vehicle,
};
